import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toJalali'
})
export class ToJalaliPipe implements PipeTransform {

  constructor()
  {}

  transform(date: Date): any {
    let m = new Date(date);
    return m.toLocaleDateString('fa')
  }

}
